import { render, staticRenderFns } from "./MessageV2.vue?vue&type=template&id=382c8210&scoped=true"
import script from "./MessageV2.vue?vue&type=script&lang=js"
export * from "./MessageV2.vue?vue&type=script&lang=js"
import style0 from "./MessageV2.vue?vue&type=style&index=0&id=382c8210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c8210",
  null
  
)

export default component.exports